module.exports = __webpack_public_path__ + "img/basimadroop.36e53f26.png";